import React from 'react';
import { useAppDispatch } from 'store/hooks';
import { setGlobalModal } from 'store/transitionSlice';
import { Resource } from 'store/types';
import WarningModal from 'components/modal/warningModal';
import { deleteRequest } from 'store/page/pageSlice';
import { useNavigate } from 'react-router-dom';

export const useDeleteHandler = ({
  contextItem,
  redirrect,
}: {
  contextItem: Resource | null;
  redirrect?: string;
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  return () => {
    if (contextItem) {
      dispatch(
        setGlobalModal(
          <WarningModal
            onCancel={() => {
              dispatch(setGlobalModal(null));
            }}
            onConfirmLoader={true}
            onConfirm={async () => {
              const result = await dispatch(
                deleteRequest({
                  _id: contextItem._id,
                  redirrect: redirrect ? redirrect : undefined,
                })
              );

              if (result.meta.requestStatus === 'fulfilled') {
                dispatch(setGlobalModal(null));

                if (redirrect) {
                  navigate(-1);
                }
              }
            }}
            mainText="Вы действительно хотите удалить медиафайл?"
            detailedText="Данное действие приведет к безвозвратному удалению медиафайла"
            buttonText="Удалить"
          ></WarningModal>
        )
      );
    }
  };
};
